/* Energy Muse homepage behaviour: the prototype's inline scripts (orchestration, the hero band, the quotes rail), verbatim. */

/* ============ orchestration: reveal + nav + theme ============ */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.documentElement.classList.add('js');
  requestAnimationFrame(function(){document.body.classList.add('loaded');});
  var btn=document.getElementById('themebtn');
  if(btn)btn.addEventListener('click',function(){
    var r=document.documentElement,c=r.getAttribute('data-theme')||(matchMedia('(prefers-color-scheme:dark)').matches?'dark':'light');
    r.setAttribute('data-theme',c==='dark'?'light':'dark');});
  /* everything is visible from the start now - see .reveal in the stylesheet */
  [].forEach.call(document.querySelectorAll('.reveal'),function(e){e.classList.add('in');});
  /* the header's scroll states and its mobile menu belong to em-header.js now */

  // announcement bar: dismiss for the session
  try{if(sessionStorage.getItem('em-ann')==='off')document.body.classList.add('ann-off');}catch(e){}

  // fold-cut: size the hero so the fold lands across the TOP of the frequency
  // numerals — their crowns showing and the rest below. The band that used to
  // sit here was a line of small grey credentials, which is a footnote and
  // cannot ask anyone to scroll; the marquee is large, copper and moving, and
  // motion at the edge of the screen is the pull. Showing it whole spent a
  // sixth of the screen on it and shortened the photograph to pay for it;
  // showing only the crowns buys that height back and asks the question
  // instead of answering it. Numerals survive being cut where a sentence does
  // not — a half-height 5 is still a 5. Deterministic on every screen.
  function foldCut(){
    var hero=document.querySelector('.hero'),au=document.querySelector('.hzband');
    if(!hero||!au)return;
    hero.style.minHeight='';
    var base=hero.getBoundingClientRect().height;
    /* the digits themselves, not the band — the band's padding is half its
       height and landing on that would show a strip of empty tint */
    var trk=au.querySelector('.track')||au;
    var r=trk.getBoundingClientRect();
    var targetDocY=r.top+window.scrollY+r.height*0.42;   // crowns only
    var mh=base+(window.innerHeight-targetDocY);
    /* On a phone the three trust items stack, so seating the author line on
       the fold asks for a hero half again as tall as the screen. That was
       survivable when the hero was type on a flat ground; with a photograph
       it is most of a screenful of empty floor under the picture. Capped just
       past one screen — the fold still lands inside the trust band, which is
       the invitation, without buying a second screen of nothing to get there.
       clientWidth, not innerWidth: some embedded viewports report the latter
       in device pixels and would take the desktop path on a phone. */
    /* On a phone the hero is a band plus a short block of type — there is
       nothing to spend extra height on but empty ground, and the trust row
       peeking under it is already the invitation to scroll. */
    if(document.documentElement.clientWidth<=840)return;
    if(mh>0)hero.style.minHeight=mh+'px';
  }
  foldCut();
  window.addEventListener('load',foldCut);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(foldCut);
  var frT;window.addEventListener('resize',function(){clearTimeout(frT);frT=setTimeout(foldCut,120);});

  /* ---- energy from the device ------------------------------------------------------------------------------------
     Sept 17, Eric: "a subtle graphic that shows pulses of energy rippling across the page, to represent the physical
     experience you have with the energy emitting from the devices." Clay, after a day of versions that invented
     their own geometry: "make it pulse from the middle and follow the coils... use the circles and such as pulses.
     dont just add cheesy fake looking rings." And once the coil was right: "i loveeee the first half... scratch the
     2nd half and build off the first half."
     The copper in the photograph is the wire. tools/hero-wire.py bakes distance from the centre into R and copper
     coverage into G; the shader samples that coverage only inside the coil. The maps still contain the old wall
     threads, but those are not drawn. The copper pulse reaches the rim, holds, and returns to the centre.
     At the rim, overlapping, broken reflections move across the plaster. Their width grows with distance,
     their shape bends with a smooth irregular field, and the photograph's texture and shadows remain visible.
     The light is carried by the surfaces in the photograph. The rim, wall and hand share one flare clock
     and dissolve fully before their pulse is retired.
     The hand and bracelets catch the same passing reflections with a softer skin response. Apple Vision mattes
     (em-hero-happy-mask.png and -p-mask.png, the generator's face taken out) separate the surfaces, while the light
     fades out of the ground under the words.
     Another hero image, or no WebGL: the photograph as shot. Reduced motion: one still frame. */
  (function(){
    var c=document.getElementById('herowave'), img=document.querySelector('.hero .hero-shot'), copy=document.querySelector('.hero .hero-copy');
    if(!c||!img)return;
    var still=matchMedia('(prefers-reduced-motion:reduce)').matches;
    var gl=c.getContext('webgl',{alpha:true,premultipliedAlpha:true,antialias:false,depth:false,stencil:false,powerPreference:'low-power'});
    if(!gl)return;
    var hp=gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER,gl.HIGH_FLOAT); if(!hp||!hp.precision)return;
    /* Each crop in the image's own 0..1 space: the coil's centre and radius, the device's edges, and the wire map's
       box and distances as shares of the image width: maxD the longest wire distance, drim where the light reaches
       the outer ring. From tools/hero-wire.py; bake again if the photograph or its crop changes. */
    var CROP={
      desk:{u:.5925,v:.3483,r:.0587,box:[.498,.136,.704,.535],light:1,  wire:{box:[0.26958,-0.29750,0.64583,1.29167],maxD:0.31333,drim:0.09697}},
      phone:{u:.5280,v:.4121,r:.1190,box:[.344,.304,.721,.514],light:.52, wire:{box:[-0.12583,0.04573,1.30833,0.73262],maxD:0.64260,drim:0.20669}}};
    var EVERY=5.0, COILT=8.0, RETD=.5, RET=2.2, FLARE=4.2, FIRST=.25, PRE=1.5, COILG=.8, SUS=.5, EMBER=.4;   /* Coverage is applied once; EMBER .4 holds a soft glow on every ring and SUS .5 keeps passed copper charged. */   /* the loop: out through the copper on the coil's clock (COILT), a hold at the rim (RETD) while the flare ignites, then back in
       to the centre (RET) where it is absorbed, and the next pulse leaves (EVERY, a little before the last is absorbed, so the
       energy reads as bouncing back out). The copper the light has passed stays charged at SUS of the pulse until the return
       gathers it, and all the copper keeps a faint EMBER, so the coil never reads dead between beats - Clay: "after the
       initial pulse, the energy on the coils seem to vanish." FLARE: seconds the light takes to dissolve. */
    var VS='attribute vec2 a;uniform vec2 uV,uQ0,uQ1;void main(){vec2 q=uQ0+a*uQ1;gl_Position=vec4(q.x/uV.x*2.-1.,1.-q.y/uV.y*2.,0.,1.);}';
    var FS='precision highp float;uniform sampler2D uM,uT,uW;uniform vec2 uV,uD,uO,uS2,uC;uniform vec4 uH,uI,uBox,uWBox;'+
      'uniform float uCoil,uWMax,uDist,uDist2,uHeadC,uTailC,uCg,uCg2,uFlare,uFlareG,uDir,uDir2,uSus,uEmber;'+
      'float run(float d,float head,float tail){return d>0.?exp(-pow(d/head,2.)):exp(-pow(d/tail,2.));}'+
      'float copper(float d,float dir){return mix(run(d,uHeadC,uTailC),run(-d,uHeadC,uTailC),.5-.5*dir);}'+
      /* Each reflection spreads and loses contrast as it travels: the brightest, clearest light belongs close to
         the copper. Staggered births and spatial focus break up the rings, with a continuous start at the source. */
      'float reflection(float d,float age,float focus){float a=max(age,0.);float travel=12.*a;'+
        'float width=.13+.055*travel+.003*travel*travel;float x=d-travel;'+
        'float disperse=1./(1.+.085*travel+.006*travel*travel);'+
        'return (exp(-pow(x/width,2.))*.62+exp(-pow(x/(width*3.2),2.))*.38)*smoothstep(0.,.09,a)*focus*disperse;}'+
      'void main(){vec2 p=vec2(gl_FragCoord.x,uD.y-gl_FragCoord.y)*uV/uD;'+
      'if(p.x<uI.x||p.y<uI.y||p.x>uI.x+uI.z||p.y>uI.y+uI.w)discard;'+
      'vec2 uv=(p-uO)/uS2;vec2 lc=(uv-uWBox.xy)/uWBox.zw;'+
      'float mapped=step(0.,lc.x)*step(0.,lc.y)*step(lc.x,1.)*step(lc.y,1.);'+
      /* The matte distinguishes skin from wall so both catch the wave with their own exposure response. It holds
         the person at 1.0 and marks the panel at .84, keeping fingers separate from the glass. */
      'float hold=texture2D(uM,uv).r;'+
      'float person=smoothstep(.88,.98,hold),clear=smoothstep(.6,1.,length((p-uH.xy)/uH.zw));float keep=(1.-person)*clear;'+
      'if(keep<.003&&person*clear<.003)discard;'+
      'vec2 bd=max(uBox.xy-p,p-uBox.xy-uBox.zw);'+
      /* Sept 21: the generator's face comes from the matte, not from the box round it. The wall light is switched
         off wherever the face is (gW below), and on a photograph where the device is turned even slightly the box
         holds bare plaster at its corners - so a dark rectangle stood on the wall with a 6px edge. The matte marks
         the panel .839 and the person 1.0, which separates the glass from the fingers on it. */
      'float face=smoothstep(.70,.80,hold)*(1.-person);'+
      'float ins=min(min(p.x-uBox.x,uBox.x+uBox.z-p.x),min(p.y-uBox.y,uBox.y+uBox.w-p.y));'+
      'float rc=distance(p,uC),r=rc/uCoil,inCoil=1.-smoothstep(uCoil*.97,uCoil*1.03,rc);'+
      'vec3 bg=texture2D(uT,uv).rgb;'+
      /* the coil: two pulses may be alive; each is a front in wire distance along the copper, with a head and a tail.
         The photograph's own copper takes the light, so it brightens as copper does */
      'vec3 w=texture2D(uW,clamp(lc,0.,1.)).rgb;float dist=w.r*uWMax,wire=w.g*inCoil*mapped;'+
      /* uDir eases the head and tail into their return orientation; an instant sign flip changes the brightness
         on either side of the rim in one frame, even though the pulse's position is continuous. */
      /* behind an outgoing front, and ahead of a returning one, the copper stays charged (dist<uDist either way); plus the ember */
      /* Keep light intensity separate from wire coverage. Multiplying both colour and alpha by coverage squared
         its small variations into bright/dark flecks; clipping RGB to white then hardened their edges. The baked
         soft coverage is now applied once, and copper highlights approach white gradually. */
      'float charge=uCg*max(copper(dist-uDist,uDir),uSus*step(dist,uDist))+uCg2*max(copper(dist-uDist2,uDir2),uSus*step(dist,uDist2))+uEmber;'+
      'vec3 colCoil=bg+(1.-bg)*(1.-exp(-bg*charge*vec3(2.8,2.2,1.4)));float alC=wire*keep;'+
      /* the rim: when the light reaches the outer ring the rim flares - a tight warm halo just outside the copper - and a
         wide soft bloom drifts outward and dissolves, warm on the black glass, a touch of brightness and warmth on the
         plaster. Nothing is drawn on the wall: the wall only catches light. uFlare runs 0..1 over the flare, -1 = none */
      'vec3 add=vec3(0.);float alF=0.;'+
      /* The flare ignites over about half a second, not a quarter. The rim lights the whole ring evenly while the
         light that preceded it sits right of the coil's centre, where the photograph's own copper is brightest, so
         igniting pulls the bright centre back about three quarters of a pixel. Spread over twice as long that is a
         glow arriving; packed into a quarter-second it reads as the coil stepping sideways - Clay: "a slight
         smallll shift right when the energy gets to the outer ring". */
      'if(uFlare>=0.){float t=uFlare,ign=smoothstep(0.,.125,t),life=(1.-smoothstep(.30,1.,t))*ign;'+
        /* All five reflections share one slowing clock. Independent easing made each late-born wave start fast
           while the earlier waves were settling. After the first 30%, speed falls continuously to zero. */
        'float settle=max(t-.30,0.);float waveClock=t-settle*settle/1.4;'+
        /* both ease to exactly zero with a flat landing, so the flare dissolves rather than vanishing - Clay: "its about
           to fade then vanishes" */
        'float rim=(exp(-pow((r-1.02)/.12,2.))+.16*exp(-pow((r-1.02)/.32,2.)))*(1.-smoothstep(.20,1.,t))*ign;'+
        /* A continuous spatial warp gives the reflections unequal, gently folded contours. It joins the circular
           rim with zero distortion, has no angular seam, and drifts much slower than the outward-moving light. */
        'vec2 q=(p-uC)/uCoil;float outside=smoothstep(1.,1.22,r);'+
        'float root=smoothstep(1.,2.5,r);'+
        'vec2 warp=vec2(.65*sin(q.y*1.10+q.x*.31+.25*t)+.28*sin(q.y*2.30-q.x*.47),.48*sin(q.x*.92-q.y*.40-.20*t)+.23*cos(q.x*1.80+q.y*.72));'+
        'vec2 projected=vec2(q.x*.91+q.y*.14,q.y*1.06);'+
        'float d=mix(r,length(projected+warp*root),root)-1.;'+
        /* Broad patches of focus interrupt the crests without drawing strands. Unequal spacing and strength keep
           the train from reading as a set of concentric rings pasted over the photograph. */
        'float f=.5+.28*sin(q.x*.72+q.y*1.31)+.22*cos(q.x*1.37-q.y*.61);'+
        'float focus=smoothstep(.18,.82,f);'+
        'float focus2=smoothstep(.20,.88,.5+.30*sin(q.x*.93-q.y*1.10+1.2)+.20*cos(q.x*.41+q.y*1.60));'+
        /* One leading reflection followed by quieter, uneven echoes, all sharing the same settling clock. */
        'float waves=1.12*reflection(d,waveClock,.08+1.12*focus)+.62*reflection(d,waveClock-.085,.08+.95*focus2)'+
          '+.43*reflection(d,waveClock-.235,.08+focus)+.28*reflection(d,waveClock-.385,.08+.90*focus2)+.18*reflection(d,waveClock-.52,.08+.85*focus);'+
        'float wake=exp(-pow((r-1.-1.8*t)/(1.+1.5*t),2.));'+
        'float reach=outside*(1.-smoothstep(6.5,8.7,r));'+
        'float bloom=(waves+.13*wake)*reach*life;'+
        'float glassA=face*smoothstep(0.,uCoil*.35,ins);'+
        'vec3 warm=vec3(1.,.72,.48);'+
        'float gG=(rim*.46+bloom*.12)*glassA,gW=bloom*(1.-face);'+
        /* Exposure follows the original surface colour: shadows stay shaded and plaster grain survives. A warm
           highlight rolls off into the photo's remaining headroom, instead of laying a flat coloured veil over it. */
        'vec3 wallLight=(1.-bg)*(1.-exp(-bg*vec3(3.0,2.15,1.25)*gW));'+
        'add=(gG*.9*warm+wallLight)*uFlareG*keep;'+
        /* The same moving crest crosses the skin. Fingers gripping the top and the thumb under the glass catch
           more light; a broad, smooth falloff keeps the palm and wrist quieter without cutting off the wave. */
        'float grip=1.-smoothstep(uCoil*.08,uCoil*.95,length(max(bd,0.)));'+
        'float skinEnergy=bloom*(.42+.46*grip)+rim*.12;'+
        'vec3 skinLight=(1.-bg)*(1.-exp(-bg*vec3(1.65,1.18,.72)*skinEnergy));'+
        'add+=skinLight*person*clear*uFlareG;'+
        /* additive light under premultiplied alpha: the alpha is just large enough that colour never exceeds it */
        'vec3 room=max(1.-bg,vec3(.02));alF=clamp(max(max(add.r/room.r,add.g/room.g),add.b/room.b),0.,1.);}'+
      'if(alC<.004&&alF<.004)discard;'+
      'alF=min(alF,1.-alC);'+
      'gl_FragColor=vec4(min(colCoil*alC+bg*alF+add,vec3(alC+alF)),alC+alF);}';
    function shader(type,src){var s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);return gl.getShaderParameter(s,gl.COMPILE_STATUS)?s:null;}
    var vs=shader(gl.VERTEX_SHADER,VS), fs=shader(gl.FRAGMENT_SHADER,FS); if(!vs||!fs)return;
    var pr=gl.createProgram(); gl.attachShader(pr,vs); gl.attachShader(pr,fs); gl.bindAttribLocation(pr,0,'a'); gl.linkProgram(pr);
    if(!gl.getProgramParameter(pr,gl.LINK_STATUS))return;
    gl.useProgram(pr);
    var U={}; ('uV uQ0 uQ1 uM uT uW uD uO uS2 uC uH uI uBox uWBox uCoil uWMax uDist uDist2 uHeadC uTailC uCg uCg2 uFlare uFlareG uDir uDir2 uSus uEmber').split(' ').forEach(function(n){U[n]=gl.getUniformLocation(pr,n);});
    gl.enableVertexAttribArray(0);
    gl.enable(gl.BLEND); gl.blendFunc(gl.ONE,gl.ONE_MINUS_SRC_ALPHA);
    var qb=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,qb); gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([0,0, 1,0, 0,1, 1,1]),gl.STATIC_DRAW);
    gl.vertexAttribPointer(0,2,gl.FLOAT,false,0,0);
    function texture(unit){
      var x=gl.createTexture(); gl.activeTexture(gl.TEXTURE0+unit); gl.bindTexture(gl.TEXTURE_2D,x);
      [[gl.TEXTURE_MIN_FILTER,gl.LINEAR],[gl.TEXTURE_MAG_FILTER,gl.LINEAR],[gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE],[gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE]].forEach(function(z){gl.texParameteri(gl.TEXTURE_2D,z[0],z[1]);});
      return x;
    }
    var mask=texture(0), photo=texture(1), wire=texture(2);
    gl.uniform1i(U.uM,0); gl.uniform1i(U.uT,1); gl.uniform1i(U.uW,2);
    var run=true, raf=0, dirty=true, dead=false, G=null, t0=null, photoAsked='', photoLoaded='';
    var got={};   /* url -> true once a data texture is on the card and read back */
    function src(){return img.currentSrc||img.src;}
    function phone(){return /-p-/.test(src());}
    function attr(n){return phone()?c.getAttribute(n+'-phone'):c.getAttribute(n);}
    /* Every texture is read back before anything is drawn: Safari can report an upload of a not-yet-decoded image
       as a success and hand over black. */
    function readback(x,pts){
      var fb=gl.createFramebuffer(), px=new Uint8Array(4), out=[];
      gl.bindFramebuffer(gl.FRAMEBUFFER,fb); gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_2D,x,0);
      if(gl.checkFramebufferStatus(gl.FRAMEBUFFER)!==gl.FRAMEBUFFER_COMPLETE)out=null;
      else pts.forEach(function(z){gl.readPixels(z[0],z[1],1,1,gl.RGBA,gl.UNSIGNED_BYTE,px); out.push([px[0],px[1],px[2]]);});
      gl.bindFramebuffer(gl.FRAMEBUFFER,null); gl.deleteFramebuffer(fb);
      return out;
    }
    function loadData(url,unit,tex,pts,ok){
      if(!url||got[url]!==undefined)return; got[url]=false;
      var mi=new Image(); mi.crossOrigin='anonymous';
      function put(tries){
        if(dead)return;
        try{gl.activeTexture(gl.TEXTURE0+unit); gl.bindTexture(gl.TEXTURE_2D,tex); gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL,gl.NONE);
          gl.texImage2D(gl.TEXTURE_2D,0,gl.RGB,gl.RGB,gl.UNSIGNED_BYTE,mi);
          gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL,gl.BROWSER_DEFAULT_WEBGL);}catch(e){dead=true;return;}
        var r=readback(tex,pts(mi)); gl.activeTexture(gl.TEXTURE0);
        if(!r||!ok(r)){ if(tries<1)setTimeout(function(){put(tries+1);},800); else dead=true; return; }
        got[url]=true; dirty=true;
      }
      mi.onload=function(){(mi.decode?mi.decode():Promise.resolve()).then(null,function(){}).then(function(){put(0);});};
      mi.src=url;
    }
    function load(){
      var s=src(); if(dead||!s||!img.complete||!img.naturalWidth)return;
      if(!/em-hero-happy/.test(s)){dead=true;return;}
      loadPhoto(s);
      var k=phone()?CROP.phone:CROP.desk;
      loadData(attr('data-mask'),0,mask,function(mi){return [[Math.floor(k.u*mi.width),Math.floor(k.v*mi.height)],[1,1]];},
        function(r){return r[0][0]>200&&r[1][0]<20;});                          /* the coil is held, a corner is not */
      loadData(attr('data-wire'),2,wire,function(mi){return [[Math.floor(mi.width/2),Math.floor(mi.height/2)],[2,2]];},
        function(r){return r[0][1]>60&&r[0][0]<40&&r[1][1]<30;});              /* wire at the centre, near none in a corner */
    }
    function loadPhoto(s){
      if(s===photoAsked)return;
      photoAsked=s;
      function put(b,tries){
        if(dead||s!==src())return;
        try{gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D,photo);
          gl.texImage2D(gl.TEXTURE_2D,0,gl.RGB,gl.RGB,gl.UNSIGNED_BYTE,b);}catch(e){gl.activeTexture(gl.TEXTURE0);dead=true;return;}
        var w=b.naturalWidth||b.width, h=b.naturalHeight||b.height;
        var r=readback(photo,[[Math.floor(w*.2),Math.floor(h*.3)],[Math.floor(w*.5),Math.floor(h*.3)],[Math.floor(w*.8),Math.floor(h*.3)]]);
        if(b!==img&&b.close)b.close();
        gl.activeTexture(gl.TEXTURE0);
        var lit=r?Math.max(r[0][0]+r[0][1]+r[0][2],r[1][0]+r[1][1]+r[1][2],r[2][0]+r[2][1]+r[2][2]):0;
        if(!r||lit<60){ if(tries<1)setTimeout(function(){put(img,tries+1);},800); else dead=true; return; }
        photoLoaded=s; dirty=true;
      }
      (img.decode?img.decode():Promise.resolve()).then(null,function(){}).then(function(){
        if(dead||s!==src())return;
        if(window.createImageBitmap)createImageBitmap(img).then(function(b){put(b,0);},function(){put(img,0);});
        else put(img,0);
      });
    }
    function geometry(){
      dirty=false; G=null;
      var cr=c.getBoundingClientRect(); if(!cr.width||!cr.height)return;
      var dpr=Math.min(window.devicePixelRatio||1,2), nw=Math.round(cr.width*dpr), nh=Math.round(cr.height*dpr);
      if(nw!==c.width||nh!==c.height){c.width=nw;c.height=nh;}
      var ir=img.getBoundingClientRect(), iw=img.naturalWidth, ih=img.naturalHeight; if(!iw||!ih||!ir.width)return;
      var k=phone()?CROP.phone:CROP.desk;
      var sc=Math.max(ir.width/iw, ir.height/ih), rw=iw*sc, rh=ih*sc;
      var pos=getComputedStyle(img).objectPosition.split(' ').map(function(z){return parseFloat(z)/100;});
      var ix=ir.left-cr.left, iy=ir.top-cr.top, ox=ix+(ir.width-rw)*(isNaN(pos[0])?.5:pos[0]), oy=iy+(ir.height-rh)*(isNaN(pos[1])?.5:pos[1]);
      var W=cr.width, H=cr.height, cx=ox+k.u*rw, cy=oy+k.v*rh, coil=k.r*rw, wb=k.wire.box;
      /* The wire bake describes copper, not the reach of reflected light on the wall. Bound the draw to the
         visible photograph; wire coverage is independently held to the baked map in the shader. */
      G={coil:coil, drim:k.wire.drim*rw, dmax:k.wire.maxD*rw*1.02, light:k.light, quad:[ix,iy,ir.width,ir.height]};
      /* where the coil's clock reaches the outer ring */
      var lo=0, hi=1, i, fr=G.drim/G.dmax; for(i=0;i<40;i++){var m=(lo+hi)/2; if(front(m)<fr)lo=m; else hi=m;}
      /* a pulse lives until both its return and its flare are done: cutting it at the return's end had cut the flare off
         at 14% and snapped it to nothing - Clay: "the ripples disappear/vanish. need to not be so instant" */
      G.tc=lo*COILT; G.life=G.tc+Math.max(RETD+RET,FLARE);
      gl.viewport(0,0,nw,nh);
      gl.uniform2f(U.uV,W,H); gl.uniform2f(U.uD,nw,nh); gl.uniform2f(U.uC,cx,cy);
      gl.uniform2f(U.uO,ox,oy); gl.uniform2f(U.uS2,rw,rh); gl.uniform4f(U.uI,ix,iy,ir.width,ir.height);
      gl.uniform4f(U.uBox,ox+k.box[0]*rw,oy+k.box[1]*rh,(k.box[2]-k.box[0])*rw,(k.box[3]-k.box[1])*rh);
      gl.uniform4f(U.uWBox,wb[0],wb[1],wb[2],wb[3]); gl.uniform1f(U.uWMax,k.wire.maxD*rw);
      gl.uniform1f(U.uCoil,coil); gl.uniform1f(U.uHeadC,coil*.16); gl.uniform1f(U.uTailC,coil*.85);
      gl.uniform1f(U.uFlareG,k.light); gl.uniform1f(U.uSus,SUS);
      gl.uniform2f(U.uQ0,G.quad[0],G.quad[1]); gl.uniform2f(U.uQ1,G.quad[2],G.quad[3]);
      var q=copy&&copy.getBoundingClientRect();
      if(q&&q.width)gl.uniform4f(U.uH,q.left-cr.left+q.width/2,q.top-cr.top+q.height/2,q.width*.75+40,q.height*.9+40);
      else gl.uniform4f(U.uH,-1e5,-1e5,1,1);
    }
    /* One front, one clock: D is how far the light has travelled along the wire from the centre of the coil. Slow
       at the heart of the coil, fastest past the rim, easing away across the wall. */
    function front(tau){tau=tau<0?0:tau>1?1:tau; var a=Math.pow(tau,2.1), b=Math.pow(1-tau,2.1); return a/(a+b);}
    function pulseAt(tp){
      /* out through the copper on the coil's clock; at the rim the light holds while the flare ignites, then it comes back in
         along the copper and is absorbed at the centre, and the next pulse leaves - a loop. Clay: "when the energy ripples
         to the outer ring it could come BACK into the middle, like its a loop" */
      var D, dir=1;
      if(tp<=G.tc)D=G.dmax*front(tp/COILT);
      else if(tp<=G.tc+RETD)D=G.drim;
      else{var returning=tp-G.tc-RETD;D=G.drim*(1-front(Math.min(1,returning/RET))); dir=1-2*front(Math.min(1,returning/.45));}   /* the turn takes .45s, not .18: at .18 the head and tail swap fast enough that the bright centre steps sideways in a frame */
      var E=Math.min(1,D/(G.coil*.5));                 /* fades in as it leaves the centre, fades out as it returns to it */
      return {D:D,E:E,dir:dir,tp:tp};
    }
    function draw(t){
      gl.clearColor(0,0,0,0); gl.clear(gl.COLOR_BUFFER_BIT);
      var alive=[], n, fi=still?1:Math.min(1,Math.max(0,(t-PRE)/1.1)); fi=fi*fi*(3-2*fi);
      if(still)alive.push(pulseAt(G.life*.45));
      else{
        var n1=Math.floor((t-FIRST)/EVERY), n0=Math.max(0,Math.floor((t-FIRST-G.life)/EVERY)+1);
        for(n=n1;n>=n0;n--){var tp=t-FIRST-n*EVERY; if(tp>=0&&tp<=G.life)alive.push(pulseAt(tp));}
      }
      var P1=alive[0]||{D:-1e4,E:0,dir:1}, P2=alive[1]||{D:-1e4,E:0,dir:1};
      /* the flare of whichever pulse reached the rim within the last FLARE seconds */
      var fl=-1; alive.forEach(function(q){var tf=q.tp-G.tc; if(tf>=0&&tf<=FLARE)fl=tf/FLARE;}); if(still)fl=.35;
      if(P1.E<=0&&P2.E<=0&&fl<0&&fi<=0)return;
      gl.uniform1f(U.uDist,P1.D); gl.uniform1f(U.uCg,COILG*P1.E*fi);
      gl.uniform1f(U.uDist2,P2.D); gl.uniform1f(U.uCg2,COILG*P2.E*fi);
      gl.uniform1f(U.uDir,P1.dir); gl.uniform1f(U.uDir2,P2.dir); gl.uniform1f(U.uEmber,COILG*EMBER*fi);
      gl.uniform1f(U.uFlare,fl);
      gl.drawArrays(gl.TRIANGLE_STRIP,0,4);
    }
    function ready(){return G&&photoLoaded===src()&&got[attr('data-mask')]===true&&got[attr('data-wire')]===true;}
    function frame(){
      raf=0; if(!run||dead)return;
      if(dirty)geometry();
      if(ready()){
        if(t0===null)t0=performance.now()-PRE*1000;   /* the first pulse is already on its way out of the coil */
        draw(still?0:(performance.now()-t0)/1000);
        if(still)return;
      } else { gl.clearColor(0,0,0,0); gl.clear(gl.COLOR_BUFFER_BIT); }
      raf=requestAnimationFrame(frame);
    }
    c.addEventListener('webglcontextlost',function(){dead=true;});
    if(window.ResizeObserver)new ResizeObserver(function(){dirty=true; if(!raf&&!dead)raf=requestAnimationFrame(frame);}).observe(c);
    else addEventListener('resize',function(){dirty=true; if(!raf&&!dead)raf=requestAnimationFrame(frame);});
    img.addEventListener('load',function(){dirty=true; load(); if(!raf&&!dead)raf=requestAnimationFrame(frame);});
    if(img.complete)load();
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){run=en[0].isIntersecting; if(run&&!raf&&!dead)raf=requestAnimationFrame(frame);},{threshold:0}).observe(c);
    }
    raf=requestAnimationFrame(frame);
  })();


})();


/* Pause the decorative wave layers outside the viewport and in background tabs (Jon, Sept 2026; the wave CSS reads
   --em-wave-play). */
(function(){
  var waves=[].slice.call(document.querySelectorAll('.sinemark'));
  function update(el){el.style.setProperty('--em-wave-play',!document.hidden&&el.dataset.inView!=='false'?'running':'paused');}
  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){entry.target.dataset.inView=String(entry.isIntersecting);update(entry.target);});
    });
    waves.forEach(function(el){observer.observe(el);});
  }
  document.addEventListener('visibilitychange',function(){waves.forEach(update);});
  waves.forEach(update);
})();


// framed photos: pointer tilt + glare (fine pointers) and scroll parallax
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fine=matchMedia('(pointer:fine)').matches;
  var cards=[].slice.call(document.querySelectorAll('.t3d'));
  var tilts=cards.concat([].slice.call(document.querySelectorAll('.int')));
  if(!tilts.length)return;
  if(fine&&!reduce)tilts.forEach(function(el){
    var small=el.classList.contains('int');
    var ax=small?3.2:5, ay=small?3.8:6;
    var rx=0,ry=0,tx=0,ty=0,gx=50,gy=20,tgx=50,tgy=20,raf=null;
    function loop(){
      rx+=(tx-rx)*0.10;ry+=(ty-ry)*0.10;gx+=(tgx-gx)*0.12;gy+=(tgy-gy)*0.12;
      el.style.setProperty('--rx',rx.toFixed(3)+'deg');
      el.style.setProperty('--ry',ry.toFixed(3)+'deg');
      el.style.setProperty('--gx',gx.toFixed(2)+'%');
      el.style.setProperty('--gy',gy.toFixed(2)+'%');
      if(Math.abs(tx-rx)>0.02||Math.abs(ty-ry)>0.02||Math.abs(tgx-gx)>0.25)raf=requestAnimationFrame(loop);
      else raf=null;
    }
    function kick(){if(!raf)raf=requestAnimationFrame(loop);}
    el.addEventListener('pointermove',function(e){
      var r=el.getBoundingClientRect();
      var nx=(e.clientX-r.left)/r.width-0.5, ny=(e.clientY-r.top)/r.height-0.5;
      tx=-ny*ax;ty=nx*ay;tgx=50+nx*64;tgy=22+ny*54;kick();
    });
    el.addEventListener('pointerleave',function(){tx=ty=0;tgx=50;tgy=20;kick();});
  });
  /* ---- the store, built from the catalogue ----

     Six products used to be typed into the markup here with their own names,
     prices and image paths - a fifth copy of data that already had a home,
     and it had gone wrong in both the ways that always go wrong: every card
     linked to gems/ rather than to its own product, so tapping a particular
     stone landed you on a grid of sixty-seven; and one of the six was the
     Rose Quartz Heart, which Energy Muse are out of. The homepage was
     selling a sold-out stone at a hardcoded price.

     One per intention, and the MEDIAN-priced one rather than the cheapest.
     Cheapest-first was tried here and on the shop rail before it, and both
     times produced a row running $3.88 to $5.88 — the whole homepage shop
     moment reading as a bargain bin. The median is the typical piece. */
  (function(){
    var host=document.getElementById('store-grid');
    if(!host||!window.EM_CATALOG)return;
    var FEEL=['Protection','Abundance','Connection','Calm','Clarity'];
    var pool=window.EM_CATALOG.all().filter(function(p){
      return (p.cat==='Crystal'||p.cat==='Jewelry') && p.stock!=='out';
    });
    var picks=[];
    /* Sept 23 (Sara): when the section names a collection, the row IS that collection's first six, in its own
       order, so Deanna and Sara can remerchandise the homepage by reordering a collection. The median-per-intention
       pick below is what runs when no collection is named. */
    var fed=window.EM_HOME_FEED;
    if(fed && fed.length){
      var byId={}; window.EM_CATALOG.all().forEach(function(p){byId[p.id]=p;});
      for(var f=0;f<fed.length;f++){ var q=byId[fed[f]]; if(q) picks.push(q); }
    }
    if(!picks.length){
      var used={};
      for(var pass=0; pass<2 && picks.length<6; pass++){
        for(var i=0;i<FEEL.length && picks.length<6;i++){
          var m=pool.filter(function(p){return p.group===FEEL[i] && !used[p.id];})
                    .sort(function(a,b){return a.price-b.price;});
          if(m.length){ var pick=m[Math.floor(m.length/2)]; used[pick.id]=1; picks.push(pick); }
        }
      }
    }
    host.innerHTML=picks.map(function(p){
      return '<article class="pcard">'
        +'<a class="shot" href="'+(window.EMBag?EMBag.href(p.id):'/products/'+encodeURIComponent(p.id))+'" aria-label="'+String(p.name).replace(/"/g,'')+'">'
        +'<img src="'+p.img+'" alt="'+String(p.name).replace(/"/g,'')+'" loading="lazy"></a>'
        +'<div class="pn">'+p.name+'</div><div class="pc">'+(EM_CATALOG.label(p.group)||p.cat)+'</div>'
        +'<div class="pf"><span class="pp">'+((p.was&&p.was>p.price)?'<s class="em-was">$'+p.was.toFixed(2)+'</s><span class="em-now">$'+p.price.toFixed(2)+'</span>':'$'+p.price.toFixed(2))+'</span>'
        /* Sept 14 (independent check): the site's one rule (snippets/em-choose.liquid) - a piece with several sizes in stock
           is chosen on its page, so its bag is a link there */
        +(p.choose
          ?'<a class="padd" href="'+(function(u){return u+(u.indexOf('?')<0?'?':'&amp;')+'choose=1';})(String(p.link||'/products/'+encodeURIComponent(p.id)))+'" aria-label="'+p.choose+': '+String(p.name).replace(/"/g,'')+'">'
          :'<button class="padd" type="button" data-id="'+encodeURIComponent(p.id)+'" aria-label="Add '+String(p.name).replace(/"/g,'')+' to bag">')
        +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.4 3h9.2l2.4 3.6v12.2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6.6Z"/><path d="M5 6.6h14"/><path d="M15.4 10.2a3.4 3.4 0 0 1-6.8 0"/></svg>'
        +(p.choose?'</a>':'</button>')+'</div>'
        +'</article>';
    }).join('');
    host.addEventListener('click',function(e){
      var b=e.target.closest('button.padd'); if(!b||!window.EMBag)return;
      var it=window.EM_CATALOG.get(decodeURIComponent(b.getAttribute('data-id')));
      if(!it)return;
      EMBag.add({id:it.id,name:it.name,price:it.price,img:it.img,link:it.home||'/shop/'});
      b.classList.add('done'); b.disabled=true;
      setTimeout(function(){b.classList.remove('done'); b.disabled=false;},1400);
    });
  })();

  /* ---- every signup form on the page behaves the same ---- */
  [].forEach.call(document.querySelectorAll('form[data-sub]'),function(fm){
    fm.addEventListener('submit',function(e){
      e.preventDefault();
      var i=fm.querySelector('input');
      if(!i||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((i.value||'').trim())){i&&i.focus();return;}
      /* one wire-up point for every form on the site - see assets/em-form.js */
      if(window.EM_FORM)EM_FORM.send('newsletter',{email:i.value.trim()});
      fm.innerHTML='<p class="sub-note" style="font-size:14px;color:var(--copper-lo);font-weight:600">'+
        'Thank you \u2014 check your inbox to confirm.</p>';
    });
  });

  /* ---- the mark is a lowercase "e", which nobody reads at rest. It turns
         as you scroll through the first screens until the letterform is
         upright and legible, then holds. ---- */
  (function(){
    /* A hint, not a new resting state: the mark turns up to the "e", holds
       it for a beat so you catch the letterform, then settles back to the
       orientation the brand actually uses. */
    var root=document.documentElement;
    function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;}
    function turn(){
      var vh=innerHeight||800;
      var up=Math.min(1,Math.max(0,scrollY/(vh*0.85)));
      var back=Math.min(1,Math.max(0,(scrollY-vh*1.25)/(vh*0.9)));
      root.style.setProperty('--m-rot',(90*(ease(up)-ease(back))).toFixed(2)+'deg');
    }
    addEventListener('scroll',turn,{passive:true});
    addEventListener('resize',turn);turn();
  })();

  /* the header's retreat-on-scroll is em-header.js's job now */

  if(!reduce){
    var ticking=false;
    var reelRow=document.querySelector('.reels');
    function upd(){
      ticking=false;var vh=innerHeight;
      /* The 24px parallax on every photograph is off: Clay saw the images
         drifting against the page as it scrolled and asked for it gone. --py
         stays defined at 0 in the stylesheet, so the transform still resolves. */
      if(reelRow){
        var rr=reelRow.getBoundingClientRect();
        var rc=(rr.top+rr.height/2-vh/2)/vh;
        reelRow.style.setProperty('--reelsx',(Math.max(-1,Math.min(1,rc))*90).toFixed(1)+'px');
      }
    }
    addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd);}},{passive:true});
    addEventListener('resize',upd);upd();


    /* the frequency band: two identical runs so the loop is seamless */
    var track=document.getElementById('hztrack');
    if(track){
      /* was a seventh hardcoded copy of the range, with one-word labels we had
         invented. Reads the canonical list now, with the short labels — "Tension
         & Stress Release" cannot sit under a 64px numeral. */
      var run='';
      (window.EM_FREQ||[]).forEach(function(f,i){
        run+='<span'+(i%3===1?' class="solid"':'')+'>'+f.hz+
             '<i>Hz '+window.EM_FREQ_BY.short(f.hz)+'</i></span>';
      });
      track.innerHTML=run+run;
    }
  }
})();

// live 3D: hero + frequency generators (shared module), scanned crystal in the final CTA
(function(){
  if(!window.WebGLRenderingContext)return;
  function golive(stage){requestAnimationFrame(function(){requestAnimationFrame(function(){stage.classList.add('live');});});}

  // frequency-section device: lazy-boot when it nears the viewport
  /* the readout ticks through the range, and the poster follows it, so the
     section shows what "seven instruments" means rather than asserting it.
     Paused for anyone who asked for less motion — they get the first one. */
  (function(){
    var hzEl=document.getElementById('freqhz');
    if(!hzEl||!window.EM_FREQ||!window.EM_FREQ.length)return;
    /* The loop is a showcase, so it shows the range as one object turning. The
       1111 breaks that twice: it is the one unit with a white body rather than
       black glass, and it is out of stock. Both are reasons to keep it off the
       front door's rotation — it still has its product page, its card on
       /frequency/ and its stop on the Frequency Room dial, where it is a thing
       you chose rather than a thing being shown to you. */
    var LOOP = window.EM_FREQ.filter(function(f){ return (f.stock||'in') !== 'out'; });
    if(!LOOP.length) LOOP = window.EM_FREQ;
    var i=0, sec=document.getElementById('freq'), on=false;
    /* The poster follows the readout again. It was decoupled when this column
       sold a copper-bodied 528; that product does not exist, so the reason for
       holding one fixed image went with it. Cross-faded between two stacked
       photographs, all seven shot at one angle, so the device re-tunes in
       place rather than cutting between pictures. */
    var pa=document.getElementById('freq-poster'), pb=document.getElementById('freq-poster2');
    var front=pa, back=pb;
    function src(hz){ return (window.EM_ASSET_BASE||'')+String(hz).replace('.','-')+'.png'; } /* the generator photographs are theme assets; EM_ASSET_BASE is set by the layout */
    function paint(){
      var f=LOOP[i%LOOP.length];
      hzEl.textContent=f.hz;
      if(!pa||!pb)return;
      var next=src(f.hz);
      if(front.getAttribute('src')===next)return;
      back.onload=function(){
        back.style.opacity='1'; front.style.opacity='0';
        var t=front; front=back; back=t;
      };
      back.alt=''; back.src=next;
    }
    paint();
    /* the other six on idle, so the first tick never fades to nothing */
    (function(){
      function pre(){ LOOP.forEach(function(f){ var im=new Image(); im.src=src(f.hz); }); }
      if('requestIdleCallback' in window) requestIdleCallback(pre); else setTimeout(pre,1600);
    })();
    if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    if('IntersectionObserver' in window && sec){
      new IntersectionObserver(function(e){on=e[0].isIntersecting;},{threshold:.25}).observe(sec);
    } else on=true;
    setInterval(function(){ if(on){i++;paint();} },2600);
  })();

  /* The WebGL generator that used to mount here rendered one generic device
     with no notion of frequency, so it could never follow the readout — and it
     cost 666KB of three.js on the front door to say nothing the photographs do
     not say better. Gone; the seven photographs cycle instead. */

})();

// reels: auto-upgrade placeholders when real films are dropped in assets/video/
document.querySelectorAll('.reel[data-video]').forEach(function(r){
  var src=r.getAttribute('data-video');
  fetch(src,{method:'HEAD'}).then(function(res){
    if(!res.ok)return;
    var v=r.querySelector('video');v.src=src;r.classList.add('live');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:.4});
    io.observe(r);
  }).catch(function(){});
});


/* The hero's band is the screen minus the header, and the header's height was
   guessed in CSS - 178px with the announcement bar, 90 without. It is measured
   now, and re-measured whenever the header changes: the bar dismissed, the bar
   wrapping to two lines, the phone turned. Clay: "make sure when a user Xs the
   quiz banner at top, the landing homepage image fills correctly". */
document.addEventListener('DOMContentLoaded', function () {
  var hero = document.querySelector('.hero'), emh = document.getElementById('emh');
  if (!hero || !emh) return;
  function fit () { hero.style.setProperty('--hdr', emh.offsetHeight + 'px'); }
  fit();
  if (window.ResizeObserver) new ResizeObserver(fit).observe(emh);
  window.addEventListener('orientationchange', function () { setTimeout(fit, 120); });
});


/* The quotes rail: which card you are on, and whether there is another one to
   the right. Both are read off scrollLeft rather than tracked, so a flick, a
   dot tap and a keyboard scroll all end up telling the same truth. */
(function(){
  var rail=document.querySelector('.proof'), dots=document.getElementById('proofdots');
  if(!rail||!dots)return;
  var cards=[].slice.call(rail.children);
  if(cards.length<2)return;

  cards.forEach(function(c,i){
    var b=document.createElement('button');
    b.type='button'; b.setAttribute('role','tab');
    b.setAttribute('aria-label','Quote '+(i+1)+' of '+cards.length);
    b.addEventListener('click',function(){
      rail.scrollTo({left:c.offsetLeft-rail.offsetLeft,behavior:'smooth'});
    });
    dots.appendChild(b);
  });
  var btns=[].slice.call(dots.children);

  /* Card offsets are measured once and re-measured on resize, so the scroll
     handler is pure arithmetic - no layout reads while the finger is moving,
     and no rAF wrapper to throttle what costs nothing. It also means a
     dispatched scroll event exercises the real path, which matters because the
     only browser available here runs the page hidden, where rAF never ticks
     and real scroll events are never emitted. */
  var offs=[];
  function measure(){
    offs=cards.map(function(c){return c.offsetLeft-rail.offsetLeft;});
  }
  function sync(){
    var x=rail.scrollLeft, best=0, dist=Infinity;
    for(var i=0;i<offs.length;i++){
      var d=Math.abs(offs[i]-x);
      if(d<dist){dist=d;best=i;}
    }
    for(var j=0;j<btns.length;j++){
      btns[j].setAttribute('aria-selected', j===best?'true':'false');
    }
    /* a couple of pixels of slack, so a fractional scrollWidth cannot leave the
       fade switched on at the very end where there is nothing left to hint at */
    rail.classList.toggle('more-right', x + rail.clientWidth < rail.scrollWidth - 2);
  }
  rail.addEventListener('scroll',sync,{passive:true});
  addEventListener('resize',function(){measure();sync();});
  measure();
  sync();
})();
